import zxcvbn from 'zxcvbn';
export enum PasswordStrength {
    none = "",
    weak = "weak",
    moderate= 'moderate',
    good = "good"
}
export const updateObject = (oldObject: any, updatedProperties: any) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

export const checkValidity = (value: any, rules: any) => {
    let isValid = true;
    if (!rules) {
        return true;
    }

    if (rules.required) {
        isValid = value != null &&  value.trim() !== '' && isValid;
    }

    if (rules.minLength) {
        isValid = value != null && value.length >= rules.minLength && isValid
    }

    if (rules.maxLength) {
        isValid = (value == null || value.length <= rules.maxLength) && isValid
    }

    if (rules.isEmail) {
        const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        isValid = pattern.test(value) && isValid
    }

    if (rules.isNumeric) {
        const pattern = /^\d+$/;
        isValid = pattern.test(value) && isValid
    }

    return isValid;
}

export const getPasswordStrength = (password: string): PasswordStrength => {

    let score = zxcvbn(password).score;
    if (score <= 1) {
        return PasswordStrength.weak;
    }
    else if (score < 3) {
        return PasswordStrength.moderate;
    }
    else {
        return PasswordStrength.good;
    }
}